import { render, staticRenderFns } from "./Ralf.vue?vue&type=template&id=3690c510&scoped=true"
import script from "./Ralf.vue?vue&type=script&lang=ts"
export * from "./Ralf.vue?vue&type=script&lang=ts"
import style0 from "./Ralf.vue?vue&type=style&index=0&id=3690c510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690c510",
  null
  
)

export default component.exports